import { Preset } from "@primeuix/themes/types";
import { environment } from "src/environments/environment";
import { GuiUtils } from "src/modules/utils/misc/gui-utils";
import { Objects } from "src/modules/utils/shared/objects";
import { ClassType } from "../../utils/shared/class-type";
import { Utils } from "../../utils/shared/utils";
import { CorporateIdentity } from "./corporate-identity.model";

export class Config {

    private static instance: Config = null;

    static get(): Config {
        if (Config.instance == null) {
            Config.instance = Objects.fromPlainUnsafe(Config, environment);
            Config.instance.validate();
        }
        return Config.instance;
    }

    //Standard Page Title. Dieser wird je nach geöffneter Ansicht überschrieben
    pageTitle: string;
    //Echtbetrieb
    production = true;
    developer = false;
    //URL des Backends
    backendUrl: string;
    mainRoute: string;
    isPortalBackend = true;
    showBreadcrumbs = true;
    breadcrumbsInToolBar = true;
    staticHeaderHtml: string = null;
    compactGui = false;
    showSidebar = true;
    showBackButton = false;
    showHelpButton = false;
    multilingual = false;
    warningOnSwitchLanguage = true;
    reportErrorsToBackend = true;
    allowAnonymous = false;
    activeModules: string[];
    modules: any[];
    privacyPolicy = false;
    backendV2 = false;
    agGridEnterpriseKey = "";
    allowDarkMode = false;
    ci = new CorporateIdentity();

    getModuleConfig<T extends object>(classType: ClassType<T>): T {
        let name = Objects.getTypeName(classType).replace("ModuleConfig", "Module").replace("Config", "Module");
        let module = this.modules?.find(m => m.name === name);
        return Objects.fromPlainUnsafe(classType, module?.config == null ? { } : module.config);
    }

    validate(): void {
        this.backendUrl ??= "";
        
        let prefix = "Fehler in der Konfigurationsdatei: ";
        if (Utils.isNoe(this.pageTitle)) {
            throw new Error(prefix + "Feld 'pageTitle' wurde nicht angegeben");
        }
        if (this.activeModules == null) {
            throw new Error(prefix + "Feld 'activeModules' wurde nicht angegeben");
        }
    }

    getPrimePreset(): Preset {
        return {
            semantic: {
                primary: GuiUtils.buildColorScale(this.ci.primaryColor)
            },
            extend: {
                app: {
                    topbar: {
                        bgColor: this.ci.topbarBgColor,
                        bgDarkColor: this.ci.topbarBgColorDark                        
                    },
                    topbarLogo: {
                        bgColor: this.ci.topbarLogoBgColor,
                        height: this.ci.topbarLogoHeight,
                        padding: this.ci.topbarLogoPadding
                    },
                    login: {
                        logoBackgroundColor: this.ci.loginLogoBackgroundColor,
                        logoPadding: this.ci.loginLogoPadding
                    },
                    primaryColor: this.ci.primaryColor,
                    primaryTextColor: this.ci.primaryTextColor
                }
            },
            css: ({ dt }) => `
                :root {
                   --p-form-field-border-radius: 4px;
                   --topbar-bg: ${dt('app.topbar.bgColor')};
                   --topbar-bg-dark: ${dt('app.topbar.bgDarkColor')};
                   --primary-color: ${dt('app.primaryColor')};
                   --primary-text-color: ${dt('app.primaryTextColor')};
                }

                .p-checkbox {
                  height: unset !important;
                }

                .login-panel img {
                    padding: ${dt('app.login.logoPadding')};
                    background-color: ${dt('app.login.logoBackgroundColor')};
                }

                .topbar-logo-img {
                    background-color: ${dt('app.topbarLogo.bgColor')};
                    height: ${dt('app.topbarLogo.height')};
                    padding: ${dt('app.topbarLogo.padding')};
                }
            `
        };
    }

}